import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import React, { useState } from "react";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { IconButton, Stack, TextField, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { Delete } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import { AsyncProductAutocomplete } from "../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import _ from "lodash";
import { VestigingFormContext } from "../../Vestigingen/VestigingForm";

export default function XPerGroupForY() {
  const { control, menukaartVestigingId, setValue, getValues, trigger, register }: VestigingFormContext =
    useFormContext<VestigingFormContext>();
  register("x_per_group_for_y");
  const { fields, append, prepend, remove, swap, move, insert, update } = useFieldArray<{
    name: string;
    numberOfProducts: number;
    productIds: number[];
  }>({
    control,
    name: "x_per_group_for_y",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Stack gap={4}>
          <TranslationWrapper tKey={"Groups"} />

          {fields.map((field, index) => {
            return (
              <Stack direction={"row"} gap={4}>
                <Typography>{field.name}</Typography>
                <TextField
                  label={"Number of products"}
                  onChange={(e) => {
                    const copy = { ...getValues("x_per_group_for_y")[index], id: field.id };
                    copy.numberOfProducts = Number(e.target.value);
                    update(index, copy);
                  }}
                  value={field.numberOfProducts}
                />

                <AsyncProductAutocomplete
                  async_url={`core/producten/search?fields=id as value, naam as label,id,naam,snaam,blocked,is_actief,prijs&per_page=50&sort_field=naam&vestiging_id=${menukaartVestigingId}`}
                  multiple={true}
                  onChange={(option) => {
                    setValue(`x_per_group_for_y.${index}.productIds`, _.chain(option).groupBy("id").keys().value());
                    const copy = { ...getValues("x_per_group_for_y")[index], id: field.id };
                    copy.productIds = _.chain(option).groupBy("id").keys().value();
                    update(index, copy);
                    // setValue(`x_per_group_for_y.${index}.productIds`, _.chain(option).groupBy("id").keys().value());
                  }}
                  value={field.productIds}
                />

                <IconButton
                  onClick={() => {
                    remove(index);
                  }}
                >
                  <Delete />
                </IconButton>
              </Stack>
            );
          })}
        </Stack>

        <AddGroup append={append} />
      </CardBody>
    </Card>
  );
}

function AddGroup({ append }) {
  const [value, setValue] = useState("");
  return (
    <Stack alignItems={"center"} direction={"row"} gap={2}>
      <TextField onChange={(e) => setValue(e.target.value)} placeholder={"Group name"} value={value} />
      <Button
        disabled={!value}
        onClick={() => {
          setValue("");
          append({ name: value, productIds: [], numberOfProducts: 1 });
        }}
      >
        <TranslationWrapper tKey={"Add group"} />
      </Button>
    </Stack>
  );
}
